import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const SidebarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 10;

  @media screen and (max-width: 820px) {
    display: none;
  }
`;

export const Content = styled.main`
  flex: 1;
  min-height: calc(100vh - 64px);
  margin-top: 64px;
  margin-left: 80px;
  padding: 24px 32px 32px;
  overflow-y: auto;

  @media screen and (max-width: 820px) {
    margin-left: 0;
    padding: 24px 16px calc(72px + env(safe-area-inset-bottom, 0));
  }
`;
